import { paths } from 'src/routes/paths';

import { getStorage } from 'src/hooks/use-local-storage';

// API
// ----------------------------------------------------------------------

export const HOST_API = import.meta.env.VITE_HOST_API;
export const ASSETS_API = import.meta.env.VITE_ASSETS_API;

export const FIREBASE_API = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APPID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const AMPLIFY_API = {
  userPoolId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  region: import.meta.env.VITE_AWS_AMPLIFY_REGION,
};

export const AUTH0_API = {
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  callbackUrl: import.meta.env.VITE_AUTH0_CALLBACK_URL,
};

export const SUPABASE_API = {
  url: import.meta.env.VITE_SUPABASE_URL,
  key: import.meta.env.VITE_SUPABASE_ANON_KEY?.trim()?.replace(/\+/g, ''),
};

export const MAPBOX_API = import.meta.env.VITE_MAPBOX_API;

export const N8N_API = {
  url: import.meta.env.VITE_N8N_URL,
  export_inventory: import.meta.env.VITE_N8N_EXPORT_INVENTORY_URL,
  import_inventory: import.meta.env.VITE_N8N_IMPORT_INVENTORY_URL,
};

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = () => {
  const localEntity = getStorage('entity');
  if (!localEntity) return paths.entity.root;

  const { id, parent } = localEntity;

  if (id) {
    if (parent) return paths.entity.modules.root(parent);
    return paths.entity.modules.root(id);
  }

  return paths.entity.root;
};
